import { createFileRoute, useParams } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { z } from "zod";
import { ApplicationDetailsPage } from "../-pages/applicationDetails";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { getApplicationDocumentTitle, useDocumentTitle } from "~/utils/document-title";

const applicationDetailSearchSchema = z.object({
  view: z.enum(["details", "notes", "activity", "documents", "chat-projects"]).optional().default("details"),
});

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/table/$applicationId")({
  staleTime: 0,
  validateSearch: applicationDetailSearchSchema,
  loader: async ({ params }) => {
    const application = await queryClient.fetchQuery(
      trpc.applications.getById.queryOptions({ id: params.applicationId }),
    );
    return { application };
  },
  component: ApplicationDetailsComponent,
});

function ApplicationDetailsComponent() {
  const { application } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  const applicationTitle = getApplicationDocumentTitle(application);
  useDocumentTitle(applicationTitle, "Application");

  useBreadCrumbs([
    { title: "Applications", link: `/${datasetSlug}/data/applications/table` },
    { title: applicationTitle, link: `/${datasetSlug}/data/applications/table/${application?.id}` },
  ]);
  return <ApplicationDetailsPage application={application} />;
}
